import React from "react";

interface SectionCardProps {
  title: string;
  badge?: string;
  badgeTone?: "coming-soon" | "info";
  testId?: string;
  children: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  badge,
  badgeTone = "coming-soon",
  testId,
  children,
}) => {
  const badgeClass =
    badgeTone === "coming-soon"
      ? "bg-[rgba(204,183,149,0.28)] text-white border border-[rgba(255,255,255,0.45)]"
      : "bg-white/15 text-white border border-white/30";
  return (
    <section
      data-testid={testId}
      className="mb-4 rounded-xl border border-[var(--js-border)] bg-white p-2 shadow-[0_1px_2px_rgba(51,66,79,0.06)]"
    >
      {/* Inset, fully-rounded blue title bar with margin to the card edges */}
      <div className="flex items-center justify-between rounded-lg bg-[var(--js-blue)] px-3 py-2 shadow-sm">
        <h2 className="text-[13px] font-semibold tracking-wide text-white">{title}</h2>
        {badge && (
          <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold leading-none ${badgeClass}`}>
            {badge}
          </span>
        )}
      </div>
      <div className="px-1.5 pt-2 pb-0.5">{children}</div>
    </section>
  );
};
